// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time[data-v-7053f5d6]{font-size:14px;font-weight:700}.content[data-v-7053f5d6]{padding-left:5px}", ""]);
// Exports
module.exports = exports;
